import { Box, Typography, Divider } from "@mui/material";
import { DetailItemProps } from '../../types';

const DetailItem: React.FC<DetailItemProps> = ({ label, value, isActionable = false, noDivider = false, variant }) => (
  <Box>
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'flex-start',
      pb: 1.5, 
      pt: 1.5, 
    }}>
      
      <Typography 
        variant={variant ? variant : "subtitle1" }
        color="text.primary" 
        sx={{ minWidth: '180px', mr: 3, flexShrink: 0, fontWeight: 600 }} 
      >
        {label}
      </Typography>
      
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          {isActionable ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body1" sx={{ flexGrow: 1 }}>{value}</Typography>
              </Box>
          ) : (
              <Typography variant="body1">{value}</Typography>
          )}
      </Box>
    </Box>
    
    {!noDivider && <Divider sx={{ my: 0.5 }} />}
  </Box>
);

export default DetailItem;